var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectModule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8753_34361)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 3.69777L1.97093e-05 7.52939H8.11453V0.993092C8.11453 0.767706 7.9538 0.542313 7.7128 0.392053C7.4718 0.241793 7.1504 0.2418 6.9094 0.31693L0.482049 3.02159C0.160682 3.09673 0 3.39725 0 3.69777ZM16 7.52939V3.69777C16 3.39725 15.8637 3.09673 15.5909 3.02159L10.1364 0.31693C9.93187 0.2418 9.65913 0.241793 9.45453 0.392053C9.25 0.542313 9.11367 0.767706 9.11367 0.993092V7.52939H16ZM6.9936e-06 8.52046H1.78921V13.7677L1.02273 14.0595C0.818193 14.1172 0.545464 14.1172 0.340919 14.0018C0.136374 13.8864 1.01725e-05 13.7133 1.01725e-05 13.5402L6.9936e-06 8.52046ZM2.78921 8.52046H4.67046V14.2575L3.81194 14.6173C3.60739 14.6808 3.33467 14.6808 3.13013 14.5538C2.92558 14.4268 2.78921 14.2363 2.78921 14.0457V8.52046ZM16 8.52046V12.3521C16 12.6525 15.8637 12.9531 15.5909 13.0282L10.1364 15.7329C9.93187 15.808 9.65913 15.808 9.45453 15.6577C9.25 15.5075 9.11367 15.2821 9.11367 15.0567V8.52046H16ZM5.67046 8.52046H8.11367V14.4815L6.6932 15.1266C6.48864 15.1954 6.21591 15.1954 6.01137 15.0578C5.80683 14.9201 5.67046 14.7137 5.67046 14.5073V8.52046Z",
    fill: "#9872FE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8753_34361"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectModule);
export default __webpack_public_path__ + "static/media/select_module.c916f620.svg";
export { ForwardRef as ReactComponent };